module.exports = __webpack_public_path__ + "static/aggregator-screen-443e3554657604bd0960ba1339b71bf6.jpg";